module.exports = __webpack_public_path__ + "img/246.ba0e984a.jpg";